<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <v-form
          v-if="!uploadEnd"
          ref="form"
          v-model="valid"
          lazy-validation
          class="form_class"
        >
          <v-btn
            block
            color="success"
            @click.native="selectFile"
            v-if="!uploadEnd && !uploading"
          >
            <v-icon left aria-hidden="true">add_a_photo</v-icon>ADICIONAR CONTAS
            DE ENERGIA
          </v-btn>
          <input
            id="files"
            type="file"
            capture="camera"
            name="file"
            ref="uploadInput"
            accept="image/*,application/pdf"
            :multiple="true"
            @change="detectFiles($event)"
          />
          <v-progress-circular
            v-if="uploading && !uploadEnd"
            :size="100"
            :width="15"
            :rotate="360"
            :value="progressUpload"
            color="success"
            >%
          </v-progress-circular>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      valid: false,
      progressUpload: 0,
      fileName: "",
      fileType: "",
      fileUrl: "",
      uploadTask: "",
      uploading: false,
      uploadEnd: false,
      downloadURL: "",
      dialog: false,
      alert: true,
    };
  },
  methods: {
    selectFile() {
      this.$refs.uploadInput.click();
    },
    detectFiles(e) {
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map((x) => {
        // const base64File = this.base64_encode(fileList[x], (base64) => {
        // })

        this.upload(fileList[x]);
      });
    },
    upload(file) {
      this.fileName = file.name;
      this.fileType = file.type;
      this.uploading = true;

      /*
            this.uploadTask = 
                firestorage
                .ref(this.fileUrl)
                .put(file)
            */
    },
    base64_encode(file, callback) {
      // read binary data
      var reader = new FileReader();
      reader.onload = (function () {
        // console.log('theFile: ', theFile)
        return function (e) {
          var binaryData = e.target.result;
          //Converting Binary Data to base 64
          var base64String = window.btoa(binaryData);
          //showing file converted to base64
          //console.log('base64String: ', base64String)
          callback(base64String);
          // alert('File converted to base64 successfuly!\nCheck in Textarea');
        };
      })(file);
      // Read in the image file as a data URL.
      reader.readAsBinaryString(file);
    },
  },
  watch: {
    uploadTask: function () {
      this.uploadTask.on(
        "state_changed",
        (sp) => {
          this.progressUpload = Math.floor(
            (sp.bytesTransferred / sp.totalBytes) * 100,
          );
        },
        null,
        () => {
          this.uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            // Adiciona o endereço do arquivo no banco de dados de lead
            /*
                    let bills = [];

                    if (this.lead.bills) {
                        bills = this.lead.bills;
                    }
                    
                    let bill = {
                        'url': downloadURL,
                        'type': this.fileType
                    }
                    bills.push(bill);
                    let data = { bills: bills, step: 1 };

                    
                    updateLead(this.lead.customer_id, data)
                    .then(() => {
                        this.lead.bills = bills;
                        this.lead.step = 1;
                        localStorage.setItem("lead", JSON.stringify(this.lead));
                    })
                    .catch(err => {
                        console.error(err);
                    });
                    */

            this.uploadEnd = true;
            this.downloadURL = downloadURL;
            this.$emit("downloadURL", downloadURL);
          });
        },
      );
    },
  },
};
</script>
<style scoped>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
</style>
